import React from 'react';
import ReactTooltip from 'react-tooltip'
import Form from '../../../components/common/Form';

class CustomSingleAcquireSubscriberFacebookPreview extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: "",
                password: ""
            },
            errors: {},
            // broadCastNumOfSubscribers: props.broadCastNumOfSubscribers || 0
        };
    }

    addDefaultSrc = (ev) =>{
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    render() {
        let props = this.props;
        // let broadCastNumOfSubscribers = this.state.broadCastNumOfSubscribers;

        return (
            <div className="col-md-6 feed-col">
                <div className="section m-lg-b">
                    <ReactTooltip/>
                    <div className="form-group choose-platform m-sm-b">
                        { props.type === 'preview' ?
                            <div className="row">
                                <label htmlFor="post-link" className="preview-label">Preview</label>
                                <ReactTooltip/>
                                <div className="col-xs-3  m-s-t">
                                    <div className="preview-platform active">
                                        <span className="fab fa-facebook-messenger"></span>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="row">
                                <p className='text-bold custom-subtitle'>
                                    Post Preview<span className="far fa-question-circle" data-tip="See how your post will look"
                                                      data-placement="top"></span>
                                </p>
                                <ReactTooltip/>
                                <div className="col-xs-3  m-s-t">
                                    <div className="preview-platform active">
                                        <span className="fab fa-facebook-messenger"></span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="preview-screen">
                        <div className="acq-subs-first-row-container">
                            <div className="round-image-container">
                                { this.props.fbPageImage ?
                                    <img src={this.props.fbPageImage} onError={this.addDefaultSrc}/>
                                    :
                                    <div style={{ backgroundColor: 'darkGrey', width: '100%', height: '100%' }}/>
                                }
                            </div>
                            <div>
                                <h3>{ this.props.fbPageName || 'Facebook page name' }</h3>
                                <p style={{color: 'lightgrey'}}>Sponsored <i className="fas fa-globe-americas"></i></p>
                            </div>
                        </div>
                        {
                            this.props.primaryText !== '' ?
                                <p className="primary-text">
                                    {this.props.primaryText}
                                </p> :
                                ''
                        }
                        {/*{ console.log('Props in CustomSinglePostPreview: ', props )}*/}
                        <div className="preview-post-picture post-picture-style"
                             style={{backgroundImage: "url(" + props.imageHashUrl + ")"}}>
                        </div>
                        <div className="preview-post-bottom-container">
                            <div className="headline-text-wrapper">
                                <p style={{width: '100%'}}>MESSENGER</p>
                                <p className="headline-text">{this.props.previewHeadline || 'Connect in messenger'}</p>
                            </div>
                            <div>
                                <h4><i className="fab fa-facebook-messenger"/> {
                                    props.buttonType === "LEARN_MORE" ? 'LEARN MORE' :
                                        props.buttonType === "CONTACT_US" ? 'CONTACT US' :
                                            props.buttonType === "SUBSCRIBE" ? 'SUBSCRIBE' :
                                                props.buttonType === "SIGN_UP" ? 'SIGN UP' : 'LEARN MORE'
                                }</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CustomSingleAcquireSubscriberFacebookPreview